import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";
import NoGapContentpoints from "../../Components/sub-pages/NoGapContent_point";

const CorporateGifting = () => {
  const CTAContent = [
    {
      pageName: "Corporate Gifting",
      paragraphitalic: "Build Stronger Business Relationships ",
      paragraphText:
        "Delight clients, partners, and prospects with thoughtfully curated corporate gifts that leave a lasting impression. From premium hampers to personalized gifts, our solutions are designed to resonate with your audience and showcase your brand values. ",
      ContactFormName: "Corporate Gifting",
    },
  ];

  const SubpgesLeftContent = [
    {
      index: 0,
      sectionName: "Custom Gifting",
      parapgraphItalic: "Highlight your company identity",
      sectionparagraphText: (
        <>
          <p>
            Create lasting impressions with gifts that speak your brand’s
            language.’
          </p>
          <p>
            At eYantra, we believe in the power of personalized gifting. Custom
            branding allows you to increase your company’s identity by creating
            memorable gifts that showcase your unique logo, colours, and
            message.
          </p>
        </>
      ),
      ImgSrc: "../assests/images/sub-pages/custom-gifting.png",
    },
    {
      index: 1,
      sectionName: "Wide Assortment:",
      parapgraphItalic: "Choose from a diverse range of options.",
      sectionparagraphText: (
        <>
          <p>
            From high-end executive gifts to affordable giveaways, find what's
            perfect for your business.
          </p>
          <p>
            With eYantra's wide assortment of corporate gifts, you can find
            something for everyone, whether it's for a large team or a select
            few. Our catalog includes a variety of products across different
            categories - tech gadgets, lifestyle items, eco-friendly gifts, and
            much more.
          </p>
        </>
      ),
      ImgSrc: "../assests/images/sub-pages/wide-assortment.png",
      categoryHeadingLeftSide: "Our Categories Include:",
      CategoriesLeftContent: [
        {
          CategoryImg: "../assests/images/sub-pages/tech-gadgets.png",
          CategoryName: "Tech Gadgets",
        },
        {
          CategoryImg: "../assests/images/sub-pages/lifestyle.png",
          CategoryName: "Lifestyle Products",
        },
        {
          CategoryImg: "../assests/images/sub-pages/eco-friendly.png",
          CategoryName: "Eco-Friendly Items",
        },
      ],
    },
   
  ];

  const noGapContent = [
    {
      RightImgNogap: "../assests/images/sub-pages/custom-branding.png",
      NogapHeading: "What Our Custom Branding Can Do? ",
      Heading: [
        {
          ListHeading: "Brand Visibility:",
          ListParagraph: "We guarantee your brand is seen with every gift.",
        },
        {
          ListHeading: "Unique Experience: ",
          ListParagraph:
            "Personalized gifts add a special touch to every occasion.",
        },
        {
          ListHeading: "Versatility",
          ListParagraph:
            "Ideal for events, corporate giveaways, and employee rewards.",
        },
      ],
      NogapSubheading: "Custom Branding Services Include:",
      Categories: [
        {
          ServiceImg: "../assests/images/sub-pages/logo-printing.png",
          ServiceText: "Logo Printing",
        },
        {
          ServiceImg: "../assests/images/sub-pages/engraving.png",
          ServiceText: "Slogan or Message Engraving ",
        },
        {
          ServiceImg: "../assests/images/sub-pages/color-matching.png",
          ServiceText: "Colour Matching and Design Customization",
        },
      ],
    },

    /**new index */
    {
      RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
      NogapHeading: "Premium Quality:",
      paragraphItalic:"Make sure every gift reflects excellence.",
      paragraphDetail:(
        <>
          <p>
            Offer your clients, employees, and partners gifts that embody your company’s standard of excellence.
          </p>
          <p>
            We know that every corporate gift should reflect the highest standards. Our premium range of corporate gifts is carefully curated to make sure that each item is crafted with precision, luxury, and durability. 
          </p>
        </>
      ),
    
      NogapSubheading: "Custom Branding Services Include:",
      Categories: [
        {
          ServiceImg: "../assests/images/sub-pages/logo-printing.png",
          ServiceText: "Executive Gifts",
        },
        {
          ServiceImg: "../assests/images/sub-pages/engraving.png",
          ServiceText: "Luxury Hampers",
        },
        {
          ServiceImg: "../assests/images/sub-pages/color-matching.png",
          ServiceText: "Premium Electronics",
        },
      ],
    },
  ];

  const NoGapContentPoints =[
    {
      RightImgNogap: "../assests/images/sub-pages/IMG-4.png",
      NogapHeading: "Why a Wide Assortment Matters:",
      Heading: [
        {
          ListHeading: "Tailored Selection:",
          ListParagraph: "No matter the size of your event or budget, we’ve got you covered.",
        },
        {
          ListHeading: "Choose What Fits Your Brand",
          ListParagraph:
            "Pick gifts that align with your corporate culture.",
        },
        {
          ListHeading: "Sustainability Options",
          ListParagraph:
            "Opt for eco-conscious gifts that speak to your brand’s values. ",
        },
      ],
     
    },
  ]

  return (
    <>
      <Helmet>
        <title>eYantra Branded Corporate Gifting</title>
        <meta name="description" content="eYantra offers branded merchandise, bulk gifting, employee gifts, joining kits, and premium company merchandise for all your corporate gifting needs."/>
        <meta name="keywords" content="eyantra, branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees"/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      
      
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      <NogapleftImg data={noGapContent[0]} />
      
      <LeftContentRightImg data={SubpgesLeftContent[1]} />
      <NoGapContentpoints data={NoGapContentPoints[0]}/>
      <NogapleftImg data={noGapContent[1]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Make every corporate gift count by aligning it with your brand message and audience preferences.
      </p>
      

    </>
  );
};

export default CorporateGifting;
